/* MALUNVI theme – vanilla JS, no dependencies */
(() => {
  const M = window.Malunvi || { routes: {}, strings: {} };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const announce = (msg) => { const r = $('#LiveRegion'); if (!r) return; r.textContent = ''; setTimeout(() => { r.textContent = msg; }, 60); };
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---------------- Header ---------------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const toggle = (btns, panel, focusSel) => {
      const open = panel.hidden;
      panel.hidden = !open;
      btns.forEach((b) => b.setAttribute('aria-expanded', String(open)));
      if (open && focusSel) { const f = $(focusSel, panel); f && f.focus(); }
      return open;
    };
    const search = $('#HeaderSearch');
    const searchBtns = $$('[data-search-toggle]');
    searchBtns.forEach((b) => b.addEventListener('click', () => {
      const opened = toggle(searchBtns, search, 'input[type="search"]');
      if (!opened) $('.site-header__search-btn')?.focus();
    }));
    const menu = $('#MobileMenu');
    const menuBtn = $('[data-menu-toggle]');
    menuBtn?.addEventListener('click', () => {
      const opened = toggle([menuBtn], menu);
      document.body.style.overflow = opened ? 'hidden' : '';
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (search && !search.hidden) { toggle(searchBtns, search); $('.site-header__search-btn')?.focus(); }
      if (menu && !menu.hidden) { toggle([menuBtn], menu); document.body.style.overflow = ''; menuBtn.focus(); }
      $$('[data-dropdown][open]').forEach((d) => { d.open = false; $('summary', d).focus(); });
    });
    document.addEventListener('click', (e) => {
      $$('[data-dropdown][open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
    });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => {
      if (e.matches && menu && !menu.hidden) { toggle([menuBtn], menu); document.body.style.overflow = ''; }
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  if (document.body.classList.contains('has-reveal')) {
    const items = $$('.reveal');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach((el) => el.classList.add('is-visible'));
    } else {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach((el) => io.observe(el));
    }
  }

  /* ---------------- Cart API ---------------- */
  const Cart = {
    sections: 'cart-drawer',
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: this.sections, sections_url: window.location.pathname })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) {
        const err = new Error(data.description || data.message || M.strings.error);
        err.data = data; throw err;
      }
      return data;
    },
    add(items) { return this.request(`${M.routes.cartAdd}.js`, { items }); },
    change(line, quantity) { return this.request(`${M.routes.cartChange}.js`, { line, quantity }); },
    async refreshCount() {
      try {
        const res = await fetch(M.routes.cartJs, { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        $$('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
          el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
        });
        return cart;
      } catch (e) { return null; }
    },
    async getSection() {
      const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      return res.text();
    }
  };

  /* ---------------- Cart drawer ---------------- */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = $('.drawer__panel', this);
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); this.close(); }
        const btn = e.target.closest('[data-qty-change]');
        if (btn) { const line = btn.closest('[data-line]'); this.updateLine(line.dataset.line, parseInt(btn.dataset.qtyChange, 10)); }
      });
      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-qty-input]');
        if (input) { const line = input.closest('[data-line]'); const q = Math.max(0, parseInt(input.value, 10) || 0); this.updateLine(line.dataset.line, q); }
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key !== 'Tab') return;
        const f = $$(FOCUSABLE, this.panel).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0]; const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-cart-toggle]');
        if (t && M.cartType !== 'page') { e.preventDefault(); this.open(t); }
      });
    }
    open(trigger) {
      this.trigger = trigger || document.activeElement;
      this.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      setTimeout(() => { (this.panel.querySelector('.drawer__header .icon-btn') || this.panel).focus(); }, reduceMotion ? 0 : 120);
    }
    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      const done = () => { this.hidden = true; };
      reduceMotion ? done() : setTimeout(done, 380);
      this.trigger && this.trigger.focus && this.trigger.focus();
    }
    render(html) {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const panel = doc.querySelector('.drawer__panel');
      if (panel) this.panel.innerHTML = panel.innerHTML;
    }
    showError(msg) {
      const el = $('[data-cart-error]', this.panel);
      if (el) { el.textContent = msg; el.hidden = false; }
    }
    async updateLine(line, quantity) {
      const body = $('[data-cart-body]', this.panel);
      body && body.setAttribute('aria-busy', 'true');
      try {
        const data = await Cart.change(parseInt(line, 10), quantity);
        this.render(data.sections && data.sections['cart-drawer']);
        await Cart.refreshCount();
        (this.panel.querySelector(`[data-line="${line}"] [data-qty-input]`) || this.panel.querySelector('.drawer__header .icon-btn'))?.focus();
      } catch (err) {
        this.render(await Cart.getSection());
        this.showError(err.message);
      } finally {
        const b = $('[data-cart-body]', this.panel); b && b.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  const afterAdd = async (data, trigger) => {
    const drawer = $('cart-drawer');
    await Cart.refreshCount();
    announce(M.strings.added);
    if (M.cartType === 'page' || !drawer) { window.location.href = M.routes.cart; return; }
    drawer.render(data.sections && data.sections['cart-drawer']);
    drawer.open(trigger);
  };

  /* ---------------- Product card ---------------- */
  class ProductCard extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse($('[data-variants]', this).textContent); } catch (e) { this.variants = []; }
      this.addBtn = $('[data-quick-add]', this);
      this.addEventListener('click', (e) => {
        const sw = e.target.closest('[data-swatch]');
        if (sw) { e.preventDefault(); this.selectSwatch(sw); }
        const add = e.target.closest('[data-quick-add]');
        if (add) { e.preventDefault(); this.quickAdd(add); }
      });
    }
    selectSwatch(sw) {
      const idx = parseInt(sw.dataset.optionIndex, 10);
      const value = sw.dataset.swatch;
      $$('[data-swatch]', this).forEach((b) => b.setAttribute('aria-pressed', String(b === sw)));
      const v = this.variants.find((x) => x.options[idx] === value && x.available) || this.variants.find((x) => x.options[idx] === value);
      if (!v) return;
      this.current = v;
      const img = $('.card__img', this);
      if (img && v.image) { img.srcset = ''; img.src = v.image; }
      const price = $('.price__current', this);
      if (price) price.textContent = v.price;
      if (this.addBtn) {
        this.addBtn.dataset.variantId = v.id;
        this.addBtn.disabled = !v.available;
        const title = $('.card__link', this)?.textContent.trim() || '';
        this.addBtn.setAttribute('aria-label', v.available ? `${M.strings.addToCart}: ${title} – ${value}` : `${M.strings.soldOut}: ${title} – ${value}`);
      }
      const stock = $('[data-stock]', this);
      if (stock) stock.innerHTML = v.available ? `<span class="dot dot--ok"></span>${M.strings.inStock}` : `<span class="dot dot--no"></span>${M.strings.soldOut}`;
    }
    async quickAdd(btn) {
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
      try {
        const data = await Cart.add([{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }]);
        btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1200);
        await afterAdd(data, btn);
      } catch (err) {
        announce(err.message);
        const drawer = $('cart-drawer');
        if (drawer) { drawer.render(await Cart.getSection()); drawer.open(btn); drawer.showError(err.message); }
      } finally {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('product-card', ProductCard);

  /* ---------------- Product page ---------------- */
  class ProductFormSection extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse($('[data-product-json]', this).textContent); } catch (e) { this.data = { variants: [] }; }
      this.form = $('form.pdp__form', this);
      this.idInput = $('[data-variant-input]', this);
      this.addBtn = $('[data-add-button]', this);
      this.errorEl = $('[data-form-error]', this);
      this.track = $('[data-gallery-track]', this);

      this.addEventListener('change', (e) => { if (e.target.matches('.option__input')) this.onOptionChange(); });
      this.addEventListener('click', (e) => {
        const step = e.target.closest('[data-step]');
        if (step) {
          const input = $('input[name="quantity"]', this);
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10));
        }
        const thumb = e.target.closest('[data-thumb]');
        if (thumb) this.showMedia(thumb.dataset.thumb, true);
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      if (this.track) {
        let t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            const slide = this.track.children[i];
            if (slide) this.markThumb(slide.dataset.mediaId);
          }, 80);
        }, { passive: true });
      }
    }
    selectedOptions() {
      return $$('fieldset.option', this).map((fs) => { const c = $('.option__input:checked', fs); return c ? c.value : null; });
    }
    onOptionChange() {
      const opts = this.selectedOptions();
      $$('fieldset.option', this).forEach((fs, i) => { const v = $('[data-option-value]', fs); if (v) v.textContent = opts[i]; });
      const variant = this.data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      this.updateVariant(variant);
    }
    updateVariant(v) {
      this.hideError();
      const label = $('[data-add-label]', this.addBtn);
      const stock = $('[data-stock]', this);
      if (!v) {
        this.addBtn.disabled = true; label.textContent = M.strings.unavailable;
        if (stock) stock.innerHTML = `<span class="dot dot--no"></span>${M.strings.unavailable}`;
        return;
      }
      this.idInput.value = v.id;
      this.addBtn.disabled = !v.available;
      label.textContent = v.available ? M.strings.addToCart : M.strings.soldOut;
      if (stock) stock.innerHTML = v.available ? `<span class="dot dot--ok"></span>${M.strings.inStock}` : `<span class="dot dot--no"></span>${M.strings.soldOut}`;
      const priceWrap = $('[data-pdp-price]', this);
      if (priceWrap) priceWrap.innerHTML = v.price_html;
      if (v.media_id) this.showMedia(String(v.media_id), false);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    showMedia(id, focus) {
      const slide = this.track && this.track.querySelector(`[data-media-id="${id}"]`);
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.markThumb(id);
      if (focus) this.track.focus({ preventScroll: true });
    }
    markThumb(id) { $$('[data-thumb]', this).forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === String(id)))); }
    hideError() { if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; } }
    async onSubmit(e) {
      if (M.cartType === 'page') return;
      e.preventDefault();
      if (this.addBtn.disabled || this.addBtn.classList.contains('is-loading')) return;
      this.hideError();
      this.addBtn.classList.add('is-loading'); this.addBtn.setAttribute('aria-busy', 'true');
      const qty = parseInt($('input[name="quantity"]', this).value, 10) || 1;
      try {
        const data = await Cart.add([{ id: parseInt(this.idInput.value, 10), quantity: qty }]);
        await afterAdd(data, this.addBtn);
      } catch (err) {
        if (this.errorEl) { this.errorEl.textContent = err.message; this.errorEl.hidden = false; }
      } finally {
        this.addBtn.classList.remove('is-loading'); this.addBtn.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('product-form-section', ProductFormSection);

  /* ---------------- Recommendations ---------------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const load = () => fetch(this.dataset.url).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector('product-recommendations');
        if (el && el.innerHTML.trim().length) this.innerHTML = el.innerHTML;
      }).catch(() => {});
      if (!('IntersectionObserver' in window)) { load(); return; }
      const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);
})();
